import {isTokenExpired} from './jwt.ts';
import {clearAuthToken, getAuthToken, getLoginRedirectTo, setLoginRedirectTo} from './storage.ts';

export function clearCredentials() {
	clearAuthToken();
}

export function isAuthenticated() {
	const token = getAuthToken();
	if (!token) {
		return false;
	}
	try {
		return !isTokenExpired(token);
	} catch (err) {
		console.error('Error checking token expiry:', err);
		clearAuthToken();
		return false;
	}
}

export function redirectToApp(location: Location) {
	const redirectTo = getLoginRedirectTo();
	setLoginRedirectTo('');

	location.href = redirectTo;
}

export function logout() {
	clearCredentials();
}
